/**
 * Cookie Banner Component
 *
 * Displays a non-intrusive cookie consent banner for first-time visitors.
 * Fixed to the bottom of the viewport with slide-up/slide-down animations.
 * Z-index 998 keeps it below the Discord popup (999).
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

interface CookieBannerProps {
  onAccept: () => void;
  onReject: () => void;
}

export function CookieBanner({ onAccept, onReject }: CookieBannerProps) {
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  const handleDismiss = (callback: () => void) => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      callback();
    }, 300);
  };

  return (
    <div className="cookie-banner-wrapper" role="dialog" aria-label="Cookie consent">
      <div className={`cookie-banner ${isAnimatingOut ? 'slide-down' : 'slide-up'}`}>
        <p className="cookie-banner-text">
          We use cookies to improve the site and for marketing purposes.{' '}
          <Link to="/privacy" className="cookie-banner-link">
            Privacy Policy
          </Link>
        </p>
        <div className="cookie-banner-actions">
          <button
            className="cookie-banner-accept"
            onClick={() => handleDismiss(onAccept)}
          >
            Accept All
          </button>
          <button
            className="cookie-banner-reject"
            onClick={() => handleDismiss(onReject)}
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
}
